var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1969 8.15338V13.551L15.2725 10.8522L11.1969 8.15338Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3283 3.769C24.9789 2.23923 23.9489 1.03483 22.6407 0.625719C20.7011 0.0176678 13.7209 0 12.9312 0C12.1416 0 5.16136 0.0176679 3.22215 0.62549C1.91356 1.03483 0.883575 2.23923 0.534328 3.76831C0.00611675 6.07501 0 10.6583 0 10.8522C0 11.0461 0.00611675 15.6294 0.534131 17.9354C0.883575 19.4652 1.91356 20.6696 3.22175 21.0787C5.16136 21.6868 12.1416 21.7044 12.9312 21.7044C13.7209 21.7044 20.7011 21.6868 22.6403 21.079C23.9489 20.6696 24.9789 19.4652 25.3281 17.9361C25.8563 15.6294 25.8624 11.0461 25.8624 10.8522C25.8624 10.6583 25.8563 6.07501 25.3283 3.769ZM9.68243 16.5826V5.12186L18.3359 10.8525L9.68243 16.5826Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.ab97d8a2b870c783d0ffdcb47c24dd50.svg";
export { ForwardRef as ReactComponent };